export interface HeaderOptions {
  title: string;
  path: string;
}

export interface ModuleROutes {
  levels: number[];
  path: string;
}

export interface userAccess {
  level: number[];
  root: string;
  routes: ModuleROutes[];
  headerOptions: HeaderOptions[];
}

export interface UserRoles {
  EMP: userAccess;
  OPS: userAccess;
  vendor: userAccess;
  CWR: userAccess;
  EMPLOYEE: userAccess;
  IOP: userAccess; // IOP hardcoded email id's have access to all the routes
}

export const userRoles: UserRoles = {
  EMP: {
    level: [2, 3, 4],
    root: 'vendor-management',
    routes: [
      { levels: [2, 3, 4], path: '' },
      { levels: [2, 3, 4], path: 'hiringrequest' },
      { levels: [2, 3, 4], path: 'edit-open-position' },
      { levels: [2, 3, 4], path: 'job-details' },
    ],
    headerOptions: [{ title: 'Contractor Hiring', path: '/hiring-manager' }],
  },
  OPS: {
    level: [2, 3, 4],
    root: 'ops-vendor-management',
    routes: [{ levels: [2, 3, 4], path: '' }],
    headerOptions: [
      { title: 'OPS', path: '/ops' },
      { title: 'OPS', path: '/ops-vendor-management' },
      { title: 'Hiring Manager', path: '/hiring-manager' },
    ],
  },
  vendor: {
    level: [2, 3, 4],
    root: 'vendorflow-dashboard',
    routes: [
      { levels: [2, 3, 4], path: '' },
      { levels: [2, 3, 4], path: 'job-details' },
    ],
    headerOptions: [
      // No header options for vendor users - they only see vendorflow dashboard
    ],
  },
  CWR: {
    level: [2, 3, 4],
    root: 'vendor-employee',
    routes: [
      { levels: [2, 3, 4], path: '' },
      { levels: [2, 3, 4], path: 'job-details' },
    ],
    headerOptions: [],
  },
  EMPLOYEE: {
    level: [],
    root: 'iskill',
    routes: [{ levels: [], path: '' }],
    headerOptions: [],
  },
  IOP: {
    level: [2, 3, 4],
    root: 'iop',
    routes: [{ levels: [2, 3, 4], path: '' }],
    headerOptions: [
      { title: 'Hiring Manager', path: '/hiring-manager' },
      { title: 'Vendor', path: '/vendor' },
      { title: 'OPS', path: '/ops' },
    ],
  },
};

export const moduleOptions: HeaderOptions[] = [
  { title: 'Hiring Manager', path: '/vendor-management' },
  { title: 'OPS', path: '/ops-vendor-management' },
  { title: 'Vendor', path: '/vendorflow-dashboard' },
];
